export function focusAndSelectInput(input: HTMLElement | null) {
  if (!(input instanceof HTMLInputElement)) {
    return;
  }
  input.focus();
  input.select();
}
